import React from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import {
  CollapsibleApplicantProfile,
} from "../../../../../shared/collapsible-applicant-profile/collapsible-applicant-profile";
import {
  ApplicantUserCitizenship,
  ApplicantUserContactInformation,
  ApplicantUserIdentityDetails,
  ApplicantUserProfessional,
  CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1Document,
  Entity,
} from "../../../../../../generated";
import { useQuery } from "@apollo/client";
import { lookupCountryQuery } from './credential-verification-v1-country-query'
import { Country } from "../../../../../../types/country";

interface CollapsibleApplicantProfileContainerProps {
  caseId: string;
}

export const CollapsibleApplicantProfileContainer: React.FC<
  CollapsibleApplicantProfileContainerProps
> = (props) => {
  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(
    CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1Document,
    {
      variables: {
        credentialVerificationCaseV1Id: props.caseId,
      },
    }
  );
  

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading || countryLoading}
      hasData={applicantDetailData}
      error={applicantDetailError || countryError}
      hasDataComponent={
        <CollapsibleApplicantProfile
          professional={applicantDetailData?.credentialVerificationCaseV1?.applicant?.personalInformation?.professional as ApplicantUserProfessional}
          contactInformation={applicantDetailData?.credentialVerificationCaseV1?.applicant?.personalInformation?.contactInformation as ApplicantUserContactInformation}
          identityDetails={applicantDetailData?.credentialVerificationCaseV1?.applicant?.personalInformation?.identityDetails as ApplicantUserIdentityDetails}
          citizenship={applicantDetailData?.credentialVerificationCaseV1?.applicant?.personalInformation?.citizenship as ApplicantUserCitizenship} 
          applyingTo={applicantDetailData?.credentialVerificationCaseV1?.applicant?.personalInformation?.applyingTo as Entity[]}  
          countryData={
            countryData?.countries?.eventPayload?.countries as Country[]
          }
        />
      }
    />
  );
};
